import { todayKey } from '~/data/weighins'

/** The moment a day and a time of day land on, as a log keeps it — the nutrition spec, Meal log. */
export function loggedMoment(day: string, time: string): number {
  const [hours, minutes] = time.split(':').map(Number)
  const at = new Date(`${day}T00:00:00`)
  at.setHours(hours ?? 0, minutes ?? 0, 0, 0)
  return at.getTime()
}

/** A day as the diary says it: today and yesterday by name, the rest by date. */
function daySaid(day: string): string {
  const today = todayKey()
  if (day === today) return 'Today'
  const yesterday = new Date(`${today}T00:00:00`)
  yesterday.setDate(yesterday.getDate() - 1)
  const key = `${String(yesterday.getFullYear())}-${String(yesterday.getMonth() + 1).padStart(2, '0')}-${String(yesterday.getDate()).padStart(2, '0')}`
  if (day === key) return 'Yesterday'
  return new Date(`${day}T00:00:00`).toLocaleDateString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  })
}

/** When a log landed, said the way the diary says a day, and the time of day on it. */
export function logMomentSaid(at: number): string {
  const when = new Date(at)
  const day = `${String(when.getFullYear())}-${String(when.getMonth() + 1).padStart(2, '0')}-${String(when.getDate()).padStart(2, '0')}`
  return `${daySaid(day)} ${String(when.getHours()).padStart(2, '0')}:${String(when.getMinutes()).padStart(2, '0')}`
}
